import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = sp.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
        if (data.payment_status === "paid") return setStatus("paid");
        if (["expired", "failed"].includes(data.status)) return setStatus("error");
      } catch (e) { console.debug("Payment status poll retry", e?.message); }
      if (tries++ < 8) setTimeout(poll, 1800);
      else setStatus("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-100 px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-10 text-center shadow-xl">
        {status === "checking" && <><Loader2 className="mx-auto h-12 w-12 animate-spin text-[#FF6A00]" /><p className="mt-4 text-gray-600">Vérification du paiement…</p></>}
        {status === "paid" && <><CheckCircle2 className="mx-auto h-14 w-14 text-emerald-500" /><h1 className="mt-4 text-2xl font-bold text-gray-900">Paiement confirmé !</h1><p className="mt-2 text-gray-500">Merci, votre règlement a bien été enregistré.</p></>}
        {(status === "error" || status === "timeout") && <><XCircle className="mx-auto h-14 w-14 text-red-500" /><h1 className="mt-4 text-2xl font-bold text-gray-900">Paiement non confirmé</h1><p className="mt-2 text-gray-500">Le paiement n'a pas pu être confirmé. Réessayez depuis votre espace.</p></>}
        <Button onClick={() => window.close()} className="mt-6 rounded-full bg-[#FF6A00] font-semibold text-white hover:bg-[#E65F00]">Fermer</Button>
      </div>
    </div>
  );
}
